module.exports = {
	"id": "ID",
	"name": "Indonesia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.009663,
			"5": 0.012884,
			"6": 0.019326,
			"7": 0.009663,
			"8": 0.003221,
			"9": 0.006442,
			"10": 0.012884,
			"11": 0.03221,
			"12": 0.012884,
			"13": 0.003221,
			"14": 0.006442,
			"15": 0.009663,
			"16": 0.006442,
			"17": 0.006442,
			"18": 0.012884,
			"19": 0.009663,
			"20": 0.009663,
			"21": 0.022547,
			"22": 0.009663,
			"23": 0.012884,
			"24": 0.009663,
			"25": 0.016105,
			"26": 0.019326,
			"27": 0.016105,
			"28": 0.022547,
			"29": 0.022547,
			"30": 0.028989,
			"31": 0.173934,
			"32": 0.022547,
			"33": 0.067641,
			"34": 0.022547,
			"35": 0.019326,
			"36": 0.016105,
			"37": 0.041873,
			"38": 0.025768,
			"39": 0.048315,
			"40": 0.038652,
			"41": 0.016105,
			"42": 0.045094,
			"43": 0.344647,
			"44": 0.061199,
			"45": 0.070862,
			"46": 0.132061,
			"47": 0.09663,
			"48": 0.151387,
			"49": 0.892217,
			"50": 0.12884,
			"51": 0.460603,
			"52": 0.315658,
			"53": 8.777225,
			"54": 2.177396,
			"55": 0.070862,
			"56": 0.019326,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.328542,
			"4": 0.019326,
			"5": 0.009663,
			"6": 0.006442,
			"7": 0.006442,
			"8": 0.009663,
			"9": 0.012884,
			"10": 0.019326,
			"11": 0.019326,
			"12": 0.048315,
			"13": 0.025768,
			"14": 0.022547,
			"15": 0.022547,
			"16": 0.035431,
			"17": 0.022547,
			"18": 0.022547,
			"19": 0.025768,
			"20": 0.025768,
			"21": 0.025768,
			"22": 0.019326,
			"23": 0.022547,
			"24": 0.028989,
			"25": 0.028989,
			"26": 0.028989,
			"27": 0.035431,
			"28": 0.025768,
			"29": 0.077304,
			"30": 0.080525,
			"31": 0.051536,
			"32": 0.051536,
			"33": 0.070862,
			"34": 0.12884,
			"35": 0.119177,
			"36": 0.135282,
			"37": 0.154608,
			"38": 0.209365,
			"39": 0.148166,
			"40": 0.151387,
			"41": 0.219028,
			"42": 0.12884,
			"43": 0.673189,
			"44": 0.325321,
			"45": 0.254459,
			"46": 0.231912,
			"47": 1.137013,
			"48": 0.863228,
			"49": 5.143937,
			"50": 0.618432,
			"51": 0.009663,
			"52": 0.003221,
			"3.5": 0.006442,
			"3.6": 0.041873
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.003221,
			"31": null,
			"32": 0.003221,
			"33": 0.003221,
			"34": 0.045094,
			"35": 0.006442,
			"36": 0.019326,
			"37": 0.196481,
			"38": 0.022547,
			"39": 0.016105,
			"40": 0.280227,
			"41": 0.038652,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.016105
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.006442,
			"6": 0.006442,
			"7": 0.012884,
			"8": 0.067641,
			"9": 0.06442,
			"10": 0.244796,
			"3.1": null,
			"3.2": null,
			"5.1": 0.019326,
			"6.1": 0.009663,
			"7.1": 0.019326,
			"9.1": 0.177155
		},
		"ios_saf": {
			"8": 0,
			"10": 1.59389664613,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0429536702748,
			"8.1-8.4": 0.0793550857619,
			"9.0-9.2": 0.0378574721066,
			"9.3": 0.577569125729
		},
		"android": {
			"3": 0,
			"4": 0.0684105116279,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00855131395349,
			"4.1": 0.246766488372,
			"4.2-4.3": 0.61691622093,
			"4.4": 1.41463165116,
			"4.4.3-4.4.4": 1.42684781395
		},
		"ie": {
			"6": 0.0132657481481,
			"7": 0.00331643703704,
			"8": 0.126024607407,
			"9": 0.0232150592593,
			"10": 0.0397972444444,
			"11": 0.242099903704,
			"5.5": null
		},
		"op_mob": {
			"0": 0.717970651231,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0199436292008
		},
		"edge": {
			"12": 0.038652,
			"13": 0.067641,
			"14": 0.106293
		},
		"ie_mob": {
			"10": 0.0534602816901,
			"11": 0.21765971831
		},
		"bb": {
			"7": 0.569352,
			"10": null
		},
		"samsung": {
			"0": 2.318076
		},
		"and_uc": {
			"0": 30.243436
		},
		"op_mini": {
			"0": 9.67309371957
		},
		"and_chr": {
			"0": 18.098872
		},
		"and_ff": {
			"0": 0.047446
		}
	},
	"total": 96.546706
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/ID.json
 ** module id = 547
 ** module chunks = 0
 **/